(() => {
  'use strict';
  if (window.__cosmoEnquiryLoaded) return;
  window.__cosmoEnquiryLoaded = true;

  const productNames = {
    mozzarella: 'mozzarella',
    burrata: 'burrata',
    mini_mozzarella: 'mini mozzarella',
    burrata_bulk: 'burrata bulk tray',
    stracciatella: 'stracciatella',
    spreadable: 'spreadable fresh cheese',
    mozzarella_iqf: 'mozzarella iqf',
    crumble_iqf: 'crumble iqf',
    grana_padano: 'grana padano',
    hard_italian: 'hard italian cheese',
    hard_wedge_150: 'hard italian cheese wedge 150 g',
    hard_wedge_500: 'hard italian cheese wedge 500 g',
    hard_grated_100: 'hard italian cheese grated 100 g',
    raspadura: 'raspadura'
  };
  const sourceNames = new Set(['home_cheese', 'cheese_collection', 'hard_retail', 'home_categories', 'dry_categories', 'frozen_categories', 'chocolate_page', 'home', 'catalogue', 'kosher', 'private_label', 'importers', 'manufacturers', 'buyer_guide', 'faq', 'about']);
  const categoryNames = new Set(['cheese', 'fresh', 'iqf', 'hard', 'antipasti', 'chocolate', 'desserts', 'kosher', 'private_label', 'dry', 'frozen']);
  const clean = (value, limit) => String(value || '').replace(/[\u0000-\u001f\u007f<>]/g, '').trim().slice(0, limit);
  const canonicalProduct = (value) => {
    const normalized = clean(value, 160).toLowerCase().replace(/[-\s]+/g, '_');
    if (Object.hasOwn(productNames, normalized)) return normalized;
    return Object.keys(productNames).find((key) => productNames[key].replace(/[-\s]+/g, '_') === normalized) || 'unspecified';
  };
  const routeName = (path = window.location.pathname) => {
    const routes = {
      '/': 'home',
      '/pages/la-bottega-cheese': 'cheese_collection',
      '/pages/contact': 'contact',
      '/pages/private-label-food-italy': 'private_label_service',
      '/pages/private-label-food-development-guide': 'buyer_guide',
      '/pages/dry-categories': 'dry_foods',
      '/pages/frozen-categories': 'frozen_foods',
      '/pages/chocolate': 'chocolate',
      '/pages/kosher-food-italy': 'kosher',
      '/pages/who-we-are': 'about',
      '/pages/faq': 'faq',
      '/pages/news': 'news',
      '/pages/i-am-a-importer': 'importer',
      '/pages/i-am-a-producer': 'manufacturer',
      '/blogs/news/private-label-food-moq-lead-time': 'moq_guide',
      '/blogs/news/chilled-frozen-cheese-importer-checklist': 'cheese_guide'
    };
    return routes[path] || (path.startsWith('/blogs/news/') ? 'news_article' : 'other');
  };
  const marketType = (value) => {
    const market = clean(value, 80).toLowerCase().replace(/[.]/g, '').replace(/\s+/g, ' ');
    if (['usa', 'us', 'united states', 'united states of america'].includes(market)) return 'usa';
    if (market === 'hong_kong') return 'hong_kong';
    if (market === 'europe_other') return 'europe_other';
    if (market === 'india') return 'india';
    if (['hong kong', 'hk'].includes(market)) return 'hong_kong';
    if (['philippines', 'the philippines'].includes(market)) return 'philippines';
    if (market === 'israel') return 'israel';
    if (market === 'italy') return 'italy';
    const europe = ['europe', 'eu', 'european union', 'austria', 'belgium', 'bulgaria', 'croatia', 'cyprus', 'czechia', 'czech republic', 'denmark', 'estonia', 'finland', 'france', 'germany', 'greece', 'hungary', 'ireland', 'latvia', 'lithuania', 'luxembourg', 'malta', 'netherlands', 'poland', 'portugal', 'romania', 'slovakia', 'slovenia', 'spain', 'sweden', 'united kingdom', 'uk', 'switzerland', 'norway', 'iceland'];
    return europe.includes(market) ? 'europe_other' : 'other_or_unspecified';
  };
  const formatType = (value) => {
    const text = clean(value, 360).toLowerCase();
    if (text === 'mixed') return 'mixed';
    const types = ['wedge', 'grated', 'raspadura', 'wheel', 'flowpack', 'cup', 'tray', 'pail', 'bag'].filter((type) => text.includes(type));
    return types.length === 1 ? types[0] : types.length > 1 ? 'mixed' : 'unspecified';
  };
  const themeRole = () => {
    const role = window.Shopify?.theme?.role;
    return role === 'main' ? 'live' : role === 'unpublished' || role === 'demo' ? 'preview' : 'unknown';
  };
  const safeMetadata = (data = {}) => ({
    product_id: canonicalProduct(data.product),
    format_type: formatType(data.format),
    source: sourceNames.has(data.source) ? data.source : 'unspecified',
    category: categoryNames.has(data.category) ? data.category : 'unspecified',
    form_type: data.formType === 'seller' ? 'seller' : data.formType === 'buyer' ? 'buyer' : 'none',
    page_type: routeName(),
    theme_role: themeRole(),
    target_market: marketType(data.market),
    contact_method: ['email', 'phone'].includes(data.contactMethod) ? data.contactMethod : 'none',
    error_type: ['client_validation', 'server_validation'].includes(data.errorType) ? data.errorType : 'none',
    schema_version: 2
  });
  let privacyState = 'loading';
  let privacyTimeout;
  const privacyCallbacks = [];
  const privacyAvailable = () => typeof window.Shopify?.customerPrivacy?.analyticsProcessingAllowed === 'function';
  const finishPrivacy = (ready) => {
    if (privacyState !== 'loading') return;
    privacyState = ready ? 'ready' : 'unavailable';
    window.clearTimeout(privacyTimeout);
    privacyCallbacks.splice(0).forEach((callback) => callback(ready));
  };
  const afterPrivacyReady = (callback) => {
    if (privacyState === 'loading') privacyCallbacks.push(callback);
    else callback(privacyState === 'ready');
  };
  const loadPrivacy = () => {
    if (privacyAvailable()) return finishPrivacy(true);
    if (typeof window.Shopify?.loadFeatures !== 'function') return finishPrivacy(false);
    privacyTimeout = window.setTimeout(() => finishPrivacy(false), 5000);
    try {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => {
        finishPrivacy(!error && privacyAvailable());
      });
    } catch (_) {
      finishPrivacy(false);
    }
  };
  const publish = (name, data) => {
    try {
      const shopify = window.Shopify;
      if (privacyState !== 'ready' || !shopify || shopify.customerPrivacy?.analyticsProcessingAllowed?.() !== true || typeof shopify.analytics?.publish !== 'function') return false;
      const result = shopify.analytics.publish('cosmo:' + name, safeMetadata(data));
      if (result && typeof result.catch === 'function') result.catch(() => {});
      return true;
    } catch (_) {
      return false;
    }
  };
  const params = new URLSearchParams(window.location.search);
  const context = {
    product: clean(params.get('lb_product'), 160),
    format: clean(params.get('lb_format'), 360),
    source: clean(params.get('lb_source'), 80),
    category: clean(params.get('lb_category'), 80),
    market: clean(params.get('lb_market'), 80)
  };
  const storage = {
    get(key) { try { return JSON.parse(window.sessionStorage.getItem(key)); } catch (_) { return null; } },
    set(key, value) { try { window.sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} },
    remove(key) { try { window.sessionStorage.removeItem(key); } catch (_) {} }
  };
  const field = (form, name) => form.elements.namedItem('contact[' + name + ']');
  const fillEmpty = (form, name, value) => {
    const input = field(form, name);
    if (input && value && !input.value) input.value = value;
  };
  const initSection = (section) => {
    if (section.dataset.cosmoContactInitialized === 'true') return;
    section.dataset.cosmoContactInitialized = 'true';
    const tabs = [...section.querySelectorAll('[data-cosmo-form-tab]')];
    const panels = [...section.querySelectorAll('[data-cosmo-form-panel]')];
    const forms = [...section.querySelectorAll('[data-cosmo-form]')];
    const storageKey = 'cosmo-contact-v07:' + section.id;
    const pending = storage.get(storageKey);
    const validPending = pending && ['buyer', 'seller'].includes(pending.formType) && Number.isFinite(pending.time) && Date.now() >= pending.time && Date.now() - pending.time < 1800000 && pending.path === window.location.pathname;
    const selectForm = (type, focusTab = false) => {
      tabs.forEach((tab) => {
        const active = tab.dataset.cosmoFormTab === type;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
        tab.tabIndex = active ? 0 : -1;
        if (active && focusTab) tab.focus();
      });
      panels.forEach((panel) => {
        const active = panel.dataset.cosmoFormPanel === type;
        panel.classList.toggle('is-active', active);
        panel.hidden = !active;
      });
    };
    tabs.forEach((tab, index) => {
      tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
      tab.addEventListener('click', () => selectForm(tab.dataset.cosmoFormTab));
      tab.addEventListener('keydown', (event) => {
        let next = null;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') next = (index + 1) % tabs.length;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') next = (index - 1 + tabs.length) % tabs.length;
        if (event.key === 'Home') next = 0;
        if (event.key === 'End') next = tabs.length - 1;
        if (next === null) return;
        event.preventDefault();
        selectForm(tabs[next].dataset.cosmoFormTab, true);
      });
    });
    forms.forEach((form) => {
      const formType = form.dataset.cosmoForm;
      const hasResponse = form.querySelector('[data-cosmo-form-errors], [data-cosmo-form-success-candidate]');
      if (form.querySelector('[data-cosmo-form-errors]') && validPending && pending.formType === formType && pending.draftContext) {
        for (const name of ['product', 'format', 'destination', 'source', 'category']) {
          fillEmpty(form, name, clean(pending.draftContext[name], name === 'format' ? 360 : name === 'product' ? 160 : 80));
        }
        if (field(form, 'format')?.value) form.querySelector('.cosmo-contact__details')?.setAttribute('open', '');
      }
      if (!hasResponse) {
        fillEmpty(form, 'source', context.source);
        fillEmpty(form, 'category', context.category);
        if (formType === 'buyer') {
          fillEmpty(form, 'product', context.product);
          fillEmpty(form, 'format', context.format);
          fillEmpty(form, 'destination', context.market);
          if (context.format) form.querySelector('.cosmo-contact__details')?.setAttribute('open', '');
        }
      }
      const summary = form.querySelector('[data-cosmo-context-summary]');
      if (summary && field(form, 'product')?.value) {
        summary.textContent = [field(form, 'product').value, field(form, 'format')?.value].filter(Boolean).join(' · ');
        form.querySelector('[data-cosmo-context]').hidden = false;
      }
      let started = false;
      let clientErrorReported = false;
      const start = () => {
        clientErrorReported = false;
        if (!started) started = publish('enquiry_start', { ...context, formType });
      };
      form.addEventListener('invalid', () => {
        if (!clientErrorReported) {
          clientErrorReported = publish('enquiry_error', { ...context, formType, errorType: 'client_validation' });
        }
      }, true);
      form.addEventListener('input', start);
      form.addEventListener('change', start);
      form.addEventListener('submit', () => {
        if (!form.checkValidity()) return;
        storage.set(storageKey, {
          formType,
          time: Date.now(),
          path: window.location.pathname,
          product: canonicalProduct(context.product),
          format: formatType(context.format),
          source: sourceNames.has(context.source) ? context.source : '',
          category: categoryNames.has(context.category) ? context.category : '',
          market: marketType(field(form, 'destination')?.value),
          draftContext: {
            product: clean(field(form, 'product')?.value, 160),
            format: clean(field(form, 'format')?.value, 360),
            destination: clean(field(form, 'destination')?.value, 80),
            source: clean(field(form, 'source')?.value, 80),
            category: clean(field(form, 'category')?.value, 80)
          }
        });
      });
    });
    const successes = [...section.querySelectorAll('[data-cosmo-form-success-candidate]')];
    if (successes.length) {
      const hashForm = forms.find((form) => '#' + form.id === window.location.hash);
      const submittedType = validPending ? pending.formType : hashForm?.dataset.cosmoForm || 'buyer';
      const success = successes.find((notice) => notice.dataset.cosmoFormSuccessCandidate === submittedType);
      if (success) {
        success.dataset.cosmoFormSuccess = submittedType;
        selectForm(submittedType);
        success.focus();
        if (validPending) {
          const successData = { product: pending.product, format: pending.format, source: pending.source, category: pending.category, formType: pending.formType, market: pending.market };
          afterPrivacyReady((ready) => {
            if (ready && Date.now() - pending.time < 1800000) publish('enquiry_success', successData);
          });
        }
      }
      storage.remove(storageKey);
    } else if (validPending && section.querySelector('[data-cosmo-form-errors]')) {
      selectForm(pending.formType);
      if (!pending.errorReported) {
        storage.set(storageKey, { ...pending, errorReported: true });
        const errorData = { product: pending.product, format: pending.format, source: pending.source, category: pending.category, formType: pending.formType, market: pending.market, errorType: 'server_validation' };
        afterPrivacyReady((ready) => {
          if (ready && Date.now() - pending.time < 1800000) publish('enquiry_error', errorData);
        });
      }
    } else if (!validPending) {
      storage.remove(storageKey);
    }
  };
  const init = (scope) => {
    if (scope.matches?.('[data-cosmo-contact]')) initSection(scope);
    scope.querySelectorAll('[data-cosmo-contact]').forEach(initSection);
  };
  document.addEventListener('click', (event) => {
    const link = event.target.closest?.('a[href]');
    if (!link || event.defaultPrevented) return;
    const data = { product: link.dataset.product, format: link.dataset.format, source: link.dataset.source, category: link.dataset.category };
    const href = link.getAttribute('href') || '';
    if (href.startsWith('mailto:') || href.startsWith('tel:')) {
      publish('contact_click', { ...data, contactMethod: href.startsWith('mailto:') ? 'email' : 'phone' });
    } else if (link.matches('.lb-catalogue-download, [data-cosmo-catalogue]') || /(?:Cosmo_Food_EU_Catalog|la-bottega-cheese-catalogue)[^?]*\.pdf(?:\?|$)/i.test(href)) {
      publish('catalogue_open', data);
    } else if (canonicalProduct(data.product) !== 'unspecified') {
      publish('product_select', data);
    }
  });
  loadPrivacy();
  init(document);
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
